import { AiOutlineClose } from "react-icons/ai";
import {
  CancelBtn,
  Header,
  MediumContainer,
  NextBtn,
} from "../../../screens/User/Users/components/IncidentType/incident.style";
import { useFormikContext } from "formik";
import { useIncidentFormContext } from "./IncidentContext";
import { updateValue } from "../../../layouts/incidentLayout/methods";

const HighSeverityConfirm = () => {
  const { setHighSeverityAcknowledged, setShowHighSeverityModal } =
    useIncidentFormContext();

  const formik = useFormikContext<{ [x: string]: any }>();

  async function handleHighSeverityConfirm() {
    await updateValue([true], setHighSeverityAcknowledged);
    formik.submitForm();
    setShowHighSeverityModal(false);
  }

  const handleModalClose = () => {
    setShowHighSeverityModal(false);
  };

  return (
    <MediumContainer>
      <div className="flex">
        <button
          onClick={handleModalClose}
          style={{
            fontSize: "30px",
            cursor: "pointer",
            backgroundColor: "transparent",
            border: "none",
          }}
        >
          <AiOutlineClose size={25} />
        </button>
        <Header>Confirm?</Header>
      </div>
      <p className="text-md px-5 py-5 text-center">
        Are you sure you want to set this incident to High Severity?
      </p>

      <div className="mb-14 mr-7 mt-5">
        <NextBtn onClick={handleHighSeverityConfirm}>Confirm</NextBtn>
        <CancelBtn onClick={handleModalClose}>Cancel</CancelBtn>
      </div>
    </MediumContainer>
  );
};

export default HighSeverityConfirm;
